/** This class provides an Interface for uploading 3dPrint-Models */
import axios from "axios";
import {eventBus} from "../events/event-bus";
import convertToFormDataObject from "@/utilities/convert-to-form-data"
import i18n from '../i18n/index'

function sendGenericErrorMessage() {
  eventBus.notification({
    type: 'warning',
    header: i18n.t('notifications.warning.header'),
    body: i18n.t('notifications.warning.body')
  });
  eventBus.fileUploadAborted();
}

export class FileUploader {
  constructor({uploadUrl}) {
    this.uploadUrl = uploadUrl;
  }

  setUID(UID) {
    this.UID = UID
  }

  getUID() {
    return this.UID;
  }

  setUploadUrl(url) {
    this.uploadUrl = url;
  }

  async trackUploadProgress(taskId) {
    return new Promise((resolve, reject) => {
      let counter = 300;
      let previousState = '';
      const pollingInterval = setInterval(async () => {
        const response = await axios.get(`${this.uploadUrl}/analytx/task/${taskId}`);
        console.log(counter)
        if (response.data !== previousState) {
          counter = 300;
          previousState = response.data;

          switch (response.data) {
            case 'converting to stl' :
              eventBus.fileUploadStateChanged({
                stateFrom: "analyzing",
                stateTo: "analyzing-vxyz",
                message: i18n.t('checkout.upload.uploadState.convertingToSTL')
              });
            case 'starting analysis':
              eventBus.fileUploadStateChanged({
                stateFrom: "uploading",
                stateTo: "analyzing",
                message: i18n.t('checkout.upload.uploadState.analyzing')
              });
              break;
            case 'repairing file':
              eventBus.fileUploadStateChanged({
                stateFrom: "uploading",
                stateTo: "analyzing",
                message: i18n.t('checkout.upload.uploadState.repairing')
              });
              eventBus.notification({
                type: 'warning',
                header: i18n.t('notifications.repairingFile.header'),
                body: i18n.t('notifications.repairingFile.body')
              });
              break;
            case 'converting to trf':
              eventBus.fileUploadStateChanged({
                stateFrom: "analyzing-vxyz",
                stateTo: "converting-to-rtf",
                message: i18n.t('checkout.upload.uploadState.convertingToTRF')
              });
              break;
            case 'analyzing volume and dimensions' :
              eventBus.fileUploadStateChanged({
                stateFrom: "analyzing",
                stateTo: "analyzing-vxyz",
                message: i18n.t('checkout.upload.uploadState.analyzingDimensions')
              });
          }
        }
        if (response.data === 'analysis completed') {
          clearInterval(pollingInterval);
          resolve();
        }
        if (--counter < 0) {
          reject();
        }
      }, 1000);
    });
  }

  async uploadFile({file, uploadUrl}) {
    this.uploadUrl = uploadUrl;
    const supportedFileTypes = ['ply', 'stl', '3ds', '3mf', 'step', 'stp'];
    const fileExtensionRegEx = /(?:\.([^.]+))?$/;
    const maxFileSize = 100000000;

    if (file.size > maxFileSize) {
      eventBus.notification({
        type: "warning",
        header: "Die Datei ist zu groß.",
        body: "Die maximale Dateigröße beträgt 100MB. Bitte lade eine Datei mit weniger als 100MB hoch."
      })
    } else if (!supportedFileTypes.includes(fileExtensionRegEx.exec(file.name)[1].toLowerCase())) {
      eventBus.notification({
        type: "warning",
        header: `Dateien vom Typ .${fileExtensionRegEx.exec(file.name)[1]} werden nicht unterstützt.`,
        body: `Unsere unterstützten Dateiformate: ${supportedFileTypes.join(', ')}`
      })
    } else {
      eventBus.fileUploadStateChanged({
        stateFrom: "before-upload",
        stateTo: "uploading",
        message: i18n.t('checkout.upload.uploadState.fileIsUploading')
      });
      const postData = convertToFormDataObject({file: file});
      try {
        const response = await axios.post(`${this.uploadUrl}/analytx/file/`, postData, {
          onUploadProgress: (progressEvent => {
            eventBus.fileUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          })
        });
        if (response.data.taskId) {
          await this.trackUploadProgress(response.data.taskId);
          return (await axios.get(`${this.uploadUrl}/analytx/file/${response.data.createdObject._id}`)).data;
        }
      } catch {
        sendGenericErrorMessage();
      }
    }
  }
}